import { IonButton, IonContent, IonFooter, useIonViewDidEnter } from '@ionic/react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '../CompleteChart.page.css'
import { runAllRules, setIsLoading } from '../../../rules/store/rules.actions'
import ErrorsAndWarningsList from '../../component/ErrorsAndWarningsList.component'
import AllErrorsCleared from '../../component/AllErrorsCleared.component'
import ButtonGroupsWithHelperText from '../../component/ButtonGroupsWithHelperText.component'
import ErrorsAndWarningsSegmentButton from '../../component/ErrorsAndWarningsSegmentButton.component'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import { useHistory } from 'react-router'
import { getSignerListSelector } from '../../selectors'
import { useTranslation } from 'react-i18next'
import { getServiceConfigSelector } from '../../../configurations/selectors/serviceConfig.selector'

const CompleteChartMobile: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const history = useHistory()
  const signerData = useSelector(getSignerListSelector)
  const { PR_SIGNATURES } = useSelector(getServiceConfigSelector)

  useIonViewDidEnter(() => {
    dispatch(setIsLoading(true))
    dispatch(runAllRules())
  })

  const onSignaturePage = () => {
    history.push(TabConstants.SIGNER_TAB)
  }

  const verifiedCount = signerData?.filter((item) => item.verified === true).length

  return (
    <IonContent fullscreen color='light' className='lock-in-chart-content'>
      <div className='d-flex align-items-center justify-content-around'>
        <ErrorsAndWarningsSegmentButton />
        {PR_SIGNATURES !== 0 && (
          <IonButton
            id={verifiedCount > 0 ? 'signature-tab-button-success' : 'signature-tab-button'}
            className={verifiedCount > 0 ? 'sc-success-bold' : 'sc-danger-bold'}
            slot='end'
            onClick={onSignaturePage}>
            {t('completeChart.signatures')}({verifiedCount}){' '}
          </IonButton>
        )}
      </div>
      <AllErrorsCleared />
      <ErrorsAndWarningsList />
      <IonFooter className='fixed-bottom-button-group-helper-text'>
        <ButtonGroupsWithHelperText />
      </IonFooter>
    </IonContent>
  )
}

export default CompleteChartMobile
